const Index = () => import(/* webpackChunkName: "purchaseOrder" */ './index.vue');
const Home = () => import(/* webpackChunkName: "purchaseOrder" */ './view/Home.vue');
const List = () => import(/* webpackChunkName: "purchaseOrder" */ './components/List.vue');
const Create = () => import(/* webpackChunkName: "purchaseOrder" */ './components/Create.vue');
const Edit = () => import(/* webpackChunkName: "purchaseOrder" */ './components/Edit.vue');


export default [
  {
    path: 'purchaseOrder',
    name: 'purchaseOrder',
    component: Index,
    redirect: { name: 'purchaseOrder-home' },
    title: 'purchaseOrder',
    children: [      
      {
        path: 'home',
        name: 'purchaseOrder-home',
        component: Home,
      },
      {
        path: 'list',
        name: 'purchaseOrder-list',
        component: List,
      },
      {
        path: 'create',
        name: 'purchaseOrder-create',
        component: Create,
      },
      {
        path: ':id/edit',
        name: 'purchaseOrder-edit',
        component: Edit,
      },    
    ],
  },
]
